import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import { Box } from 'theme-ui';
export default function ScaleResume({
  children,
}: {
  children: React.ReactNode;
}) {
  const RESUME_WIDTH = 1030;
  const parentRef = useRef<HTMLDivElement>(null);
  const resumeRef = useRef<HTMLDivElement>(null);
  const [resumeHeight, setResumeHeight] = useState(-1);
  const [parentWidth, setParentWidth] = useState(-1);
  useEffect(() => {
    if (parentRef.current) {
      setParentWidth(parentRef.current.offsetWidth);
    }

    if (resumeRef.current) {
      setResumeHeight(resumeRef.current.offsetHeight);
    }
  }, [parentRef, resumeRef, children]);
  let scaleFactor = 1;

  // Don't set the scaleFactor if we don't have dimensions yet
  if (parentWidth !== -1) {
    scaleFactor = parentWidth / RESUME_WIDTH;
  }

  return (
    <div ref={parentRef}>
      <Box
        sx={{
          width: RESUME_WIDTH * scaleFactor,
          height: resumeHeight * scaleFactor,
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            transform: `scale(${scaleFactor})`,
            transformOrigin: 'top left',
          }}
        >
          <Box
            sx={{
              width: RESUME_WIDTH,
            }}
            ref={resumeRef}
          >
            {children}
          </Box>
        </Box>
      </Box>
    </div>
  );
}
